import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon CheckMarkIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const CheckMarkIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 20 14">
      <path d="M7.318 14a1.563 1.563 0 01-1.132-.488L.447 7.482A1.644 1.644 0 01.477 5.2a1.558 1.558 0 012.234.03l4.651 4.887L17.335.445a1.55 1.55 0 012.232.061 1.64 1.64 0 01-.06 2.282L8.4 13.556A1.553 1.553 0 017.318 14z" />
    </Icon>
  )
}
export default CheckMarkIcon
